import { gsap } from "gsap";
import DrawSVGPlugin from "gsap/DrawSVGPlugin";
import { returnBorderAnimation, setProjectArchiveScrollPos } from "../../app";
import initProjectSingle from "../projectSingle";

gsap.registerPlugin(DrawSVGPlugin);

export default function projectSingleEnterDesktop(data, isMobile, isTouch) {
  if (isMobile) {
    var tl = gsap
      .timeline()
      .set(".wipe-wrapper", {
        autoAlpha: 0,
      })
      .set(data.next.container, {
        autoAlpha: 1,
      })
      .set(".hide-on-load", {
        autoAlpha: 1,
      })
      .from(".project-single__hero--img", {
        autoAlpha: 0,
        xPercent: 10,
      })
      .from(
        ".project-single__hero--header",
        {
          autoAlpha: 0,
          xPercent: 10,
        },
        "<50%"
      )
      .from(
        ".project-single__hero--copy",
        {
          autoAlpha: 0,
          yPercent: 10,
        },
        "<50%"
      );
    returnBorderAnimation(
      tl,
      ".project-single__hero .link--bordered--border",
      "<"
    );
    tl.from(".project-single__hero--meta--group", {
      autoAlpha: 0,
      stagger: 0.1,
    });

    return tl;
  }
  var tl = gsap
    .timeline()
    .set(".wipe-wrapper", {
      autoAlpha: 0,
    })
    .set(data.next.container, {
      autoAlpha: 1,
    })
    .set(".hide-on-load", {
      autoAlpha: 1,
    })
    .from(".project-single__hero--img", {
      xPercent: -100,
      autoAlpha: 0,
    })
    .from(
      ".project-single__hero--header",
      {
        xPercent: -20,
        autoAlpha: 0,
      },
      "<50%"
    )
    .from(
      ".project-single__hero--copy",
      {
        xPercent: -20,
        autoAlpha: 0,
      },
      "<50%"
    );
  returnBorderAnimation(
    tl,
    ".project-single__hero .link--bordered--border",
    "<"
  );
  tl.from(
    ".project-single__hero--meta--group",
    {
      autoAlpha: 0,
      stagger: 0.1,
    },
    "<50%"
  )
    .set(".project-single__hero--coord svg path", {
      drawSVG: "0%",
    })
    .from(
      ".project-single__hero .coord",
      {
        autoAlpha: 0,
      },
      "<"
    )
    .from(
      ".project-single__hero .coord--line",
      {
        width: "0",
      },
      "<"
    )
    .fromTo(
      ".project-single__hero .bp .draw-on-load",
      {
        drawSVG: "0%",
      },
      {
        drawSVG: "100%",
        ease: "none",
      },
      "<"
    );
  return tl;
}
